import { WitboostSearchApi } from '../WitboostSearchApi';
import { sleep } from '@agilelab/plugin-wb-platform-common';
import { generateFakeResults } from './fakeResults';
import {
  AvailableSearchFilterValues,
  WitboostMarketplaceSearchResultSet,
  WitboostSearchQuery,
} from '@agilelab/plugin-wb-search-common';
import { SearchQuery } from '@backstage/plugin-search-common';
import { ApiRef, createApiRef } from '@backstage/core-plugin-api';

export class MockWitboostSearchApi implements WitboostSearchApi {
  async getAvailableFilterValues(): Promise<AvailableSearchFilterValues> {
    return {};
  }

  async query(
    _query: SearchQuery,
  ): Promise<WitboostMarketplaceSearchResultSet> {
    await sleep(200);
    const results = generateFakeResults(15);
    return { results, numberOfResults: results.length };
  }

  async queryPost(
    query: WitboostSearchQuery,
  ): Promise<WitboostMarketplaceSearchResultSet> {
    await sleep(200);

    const numberOfResults = query.pageLimit || 15;
    const results = generateFakeResults(numberOfResults);

    const hasMoreResults = numberOfResults >= 10;
    const nextPageCursor = hasMoreResults ? 'mock-cursor-12345' : undefined;

    return {
      results,
      numberOfResults: results.length,
      nextPageCursor,
    };
  }
}

export const witboostMockSearchApiRef: ApiRef<WitboostSearchApi> =
  createApiRef<WitboostSearchApi>({
    id: 'witboost.search.mock',
  });
